import strings from "rivals/shared/strings/common";

const { add, added, remove } = strings;

export default {
  add,
  added,
  included: "Included",
  remove
};
